import { IError } from 'types';

export function isErrorWithUserMessage<T extends object>(response: T | IError): response is IError {
  return 'userErrorMessage' in response && response.userErrorMessage !== null;
}
